/* CPPerformance — Uitlaatsierstukken visibility + safe fitment layer */
(function () {
  const COLLECTION_URL = '/collections/uitlaat-sierstukken';
  const COLLECTION_IMAGE = 'https://cdn.shopify.com/s/files/1/0951/4742/6167/collections/Schermopname_9-10-2025_15264_www.google.nl.jpg?v=1760103004';
  const BMW_X5_G05_TIPS_ID = '15445810610551';

  function el(html) {
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  function norm(value) {
    return String(value || '').toLowerCase().trim().replace(/\s+/g, ' ');
  }

  function mountHomepageQuickLinks() {
    const main = document.querySelector("main[data-template='index']");
    if (!main) return;

    const links = main.querySelector('.cp-home-quicknav__links');
    if (links && !links.querySelector('a[href="' + COLLECTION_URL + '"]')) {
      const montage = links.querySelector('a[href*="#montage-afspraak"]');
      const link = el('<a href="' + COLLECTION_URL + '">Sierstukken</a>');
      if (montage) montage.insertAdjacentElement('beforebegin', link);
      else links.appendChild(link);
    }

    document.querySelectorAll('.cp-drawer-shortcuts__grid').forEach(function (grid) {
      if (grid.querySelector('a[href="' + COLLECTION_URL + '"]')) return;
      const montage = grid.querySelector('a[href*="#montage-afspraak"]');
      const link = el('<a href="' + COLLECTION_URL + '">Sierstukken</a>');
      if (montage) montage.insertAdjacentElement('beforebegin', link);
      else grid.appendChild(link);
    });
  }

  function findCategorySection(main) {
    const headings = Array.from(main.querySelectorAll('h2'));
    const heading = headings.find(function (node) {
      return norm(node.textContent).indexOf('shop op categorie') > -1;
    });
    if (heading) return heading.closest('.shopify-section') || heading.parentElement;
    const list = main.querySelector('.collection-list');
    return list ? (list.closest('.shopify-section') || list.parentElement) : null;
  }

  function mountHomepageSpotlight() {
    const main = document.querySelector("main[data-template='index']");
    if (!main) return;
    main.querySelectorAll('[data-cp-sierstukken-spotlight]').forEach(function (node) { node.remove(); });
  }

  function mountSierstukkenCollection() {
    const path = window.location.pathname.replace(/\/+$/, '');
    if (path !== COLLECTION_URL) return;

    const main = document.querySelector("main[data-template^='collection']");
    if (!main) return;
    main.classList.add('cp-sierstukken-page');

    const heading = main.querySelector('h1');
    if (heading && !main.querySelector('.cp-sierstukken-page__eyebrow')) {
      heading.insertAdjacentElement(
        'beforebegin',
        el('<span class="cp-sierstukken-page__eyebrow">CPPerformance • Uitlaatafwerking</span>')
      );
    }

    const intro = main.querySelector('.cp-collection-intro');
    if (intro && !intro.querySelector('.cp-sierstukken-page__lead')) {
      const lead = el(`
        <div class="cp-sierstukken-page__lead">
          <strong>Uitlaatsierstukken voor een sportievere afwerking.</strong>
          <span>Voertuigspecifieke varianten herken je aan het automodel in de producttitel. Bij universele sierstukken controleer je aansluiting, diameter en bumperuitsparing.</span>
        </div>
      `);
      const text = intro.querySelector('.cp-collection-intro__text');
      if (text) text.insertAdjacentElement('beforebegin', lead);
      else intro.insertAdjacentElement('afterbegin', lead);
    }

    if (!intro && heading && !main.querySelector('[data-cp-sierstukken-fallback-intro]')) {
      const headerSection = heading.closest('.shopify-section') || heading.parentElement;
      const fallback = el(`
        <div class="cp-sierstukken-fallback-intro" data-cp-sierstukken-fallback-intro>
          <div>
            <strong>Uitlaatsierstukken voor een sportievere afwerking.</strong>
            <p>Voertuigspecifieke varianten herken je aan het automodel in de producttitel. Bij universele sierstukken controleer je aansluiting, diameter en bumperuitsparing.</p>
          </div>
          <div class="cp-sierstukken-fallback-intro__actions">
            <a href="/#vehicle-finder-metafield_PPhQTd">Gebruik Vehicle Finder</a>
            <a href="/pages/contact">Vraag pasvorm na</a>
          </div>
        </div>
      `);
      headerSection.insertAdjacentElement('afterend', fallback);
    }
  }

  function selectedText(select) {
    return select && select.selectedOptions && select.selectedOptions[0]
      ? select.selectedOptions[0].textContent
      : '';
  }

  function syncKnownSierstukFitment(root) {
    if (!root) return;
    const brand = root.querySelector('[data-vehicle-brand]');
    const model = root.querySelector('[data-vehicle-model]');
    const generation = root.querySelector('[data-vehicle-generation]');
    const button = root.querySelector('[data-vehicle-submit]');
    const count = root.querySelector('[data-vehicle-count]');
    if (!brand || !model || !generation || !button) return;

    const isKnownBMWX5G05 =
      norm(selectedText(brand)).indexOf('bmw') > -1 &&
      norm(selectedText(model)) === 'x5' &&
      norm(selectedText(generation)).indexOf('g05') > -1;

    if (!isKnownBMWX5G05 || !button.getAttribute('href')) return;

    try {
      const url = new URL(button.getAttribute('href'), window.location.origin);
      const ids = (url.searchParams.get('vehicle_ids') || '')
        .split(',')
        .map(function (id) { return id.trim(); })
        .filter(Boolean);

      if (ids.indexOf(BMW_X5_G05_TIPS_ID) === -1) ids.push(BMW_X5_G05_TIPS_ID);
      url.searchParams.set('vehicle_ids', ids.join(','));
      button.setAttribute('href', url.pathname + url.search + url.hash);

      if (count) {
        const single = root.dataset.countSingle || '1 product beschikbaar';
        const plural = root.dataset.countPlural || '[count] producten beschikbaar';
        count.textContent = ids.length === 1 ? single : plural.replace('[count]', ids.length);
      }
    } catch (e) {
      /* Keep the original Finder link if a malformed URL is ever returned. */
    }
  }

  function bindFinder() {
    document.querySelectorAll('[data-vehicle-finder]').forEach(function (root) {
      if (root.dataset.cpSierstukkenBound === 'true') {
        window.setTimeout(function () { syncKnownSierstukFitment(root); }, 0);
        return;
      }
      root.dataset.cpSierstukkenBound = 'true';
      root.addEventListener('change', function () {
        window.setTimeout(function () { syncKnownSierstukFitment(root); }, 0);
      });
      window.setTimeout(function () { syncKnownSierstukFitment(root); }, 0);
    });
  }

  function mountVehicleResultsCallout() {
    const params = new URLSearchParams(window.location.search);
    const isVehicleResult =
      (params.get('q') || '').toLowerCase().indexOf('cpfitment') > -1 ||
      Boolean(params.get('vehicle_ids'));
    if (!isVehicleResult || document.querySelector('[data-cp-vehicle-sierstukken-callout]')) return;

    const results = document.querySelector('results-list');
    const main = document.querySelector('main');
    if (!results || !main) return;

    const callout = el(`
      <aside class="cp-vehicle-sierstukken-callout" data-cp-vehicle-sierstukken-callout>
        <div>
          <span class="cp-vehicle-sierstukken-callout__eyebrow">Extra afwerking</span>
          <strong>Ook uitlaatsierstukken bekijken?</strong>
          <p>Universele sierstukken tonen we bewust niet als ‘passend’. Controleer aansluiting en diameter of laat ons de pasvorm checken.</p>
        </div>
        <a href="${COLLECTION_URL}">Bekijk sierstukken →</a>
      </aside>
    `);
    results.insertAdjacentElement('beforebegin', callout);
  }

  function mountAll() {
    mountHomepageQuickLinks();
    mountHomepageSpotlight();
    mountSierstukkenCollection();
    bindFinder();
    mountVehicleResultsCallout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(mountAll, 0);
  });

  const observer = new MutationObserver(function () {
    window.clearTimeout(observer._cpSierstukkenTimer);
    observer._cpSierstukkenTimer = window.setTimeout(mountAll, 140);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
